module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/102/assets/images/7907b7476e7b8eaedb4309dc0274fbd5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_unassign.svg
// module id = 5i2N
// module chunks = 0